import VenueSheetContent from "@/components/VenueDetailSheet/components/VenueSheetContent";
import { useCustomToast } from "@/hooks/useCustomToast";
import { useDarkMode } from "@/hooks/useDarkMode";
import { useGeoLocation } from "@/hooks/useGeoLocation";

import { useVenueDetailsBySlug } from "common/hooks";
import { Venue } from "common/types";
import React, { useEffect } from "react";
import { ThreeDots } from "react-loader-spinner";
import { Storage } from "common/storage";

function VenueDetails(props: { selectedVenue: Venue; onBack: () => void }) {
  const isDark = useDarkMode();
  const { location } = useGeoLocation();

  const showToast = useCustomToast();

  const { data, error, isLoading, refetch } = useVenueDetailsBySlug({
    slug: props.selectedVenue.business.slug,
    latitude: location?.latitude.toString(),
    longitude: location?.longitude.toString(),
    accessToken: Storage.getCurrentUserToken() || "",
    enabled: location ? true : false,
  });

  useEffect(() => {
    if (location) {
      refetch();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location]);

  useEffect(() => {
    if (error) {
      showToast(error.message, "error");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [error, isDark]);

  if (!data || isLoading) {
    return (
      <div className="flex-1 h-[calc(100vh-200px)] items-center justify-center flex">
        <div className="w-[80px] h-[50px] bg-white flex justify-center items-center rounded-full">
          <ThreeDots
            visible={true}
            height="35"
            width="35"
            color={isDark ? "#D3D3D9" : "#151A36"}
            radius="9"
            ariaLabel="three-dots-loading"
            wrapperStyle={{}}
            wrapperClass=""
          />
        </div>
      </div>
    );
  }
  return (
    <div>
      <VenueSheetContent
        venueDetailsReponse={data}
        onClose={props.onBack}
        onRefresh={() => setTimeout(() => refetch(), 1000)}
        fullSize={false}
      />
    </div>
  );
}

export default VenueDetails;
